export const salesPageData = {
  codesButtonStates: {
    disapproved: "Desaprobado",
    approved: "Aprobado",
    in_progress: "En Proceso",
    default: "None",
  },
  salesTableColumns: [
    {
      label: "Nombre",
      property: "lastName",
      responsive: {
        state: true,
        order: 1,
      },
      styles: {
        mobile: {
          width: "75px",
        },
      },
    },
    {
      label: "País",
      property: "countryId",
      responsive: { state: false },
    },
    {
      label: "Fecha Compra",
      property: "paymentDate",
      responsive: { state: true, order: 3 },
    },
    {
      label: "Desafío",
      property: "description",
      responsive: { state: true, order: 2 },
    },
    {
      label: "Cuenta",
      property: "balance",
      responsive: { state: false },
    },
    {
      label: "Mail",
      property: "email",
      responsive: { state: false },
    },
    {
      label: "Saldo Actual",
      property: "mt5AccountBalance",
      responsive: {state: false}
    },
    {
      label: "Comisión",
      property: "partnerBenefitAmount",
      responsive: {state: false}
    },
    {
      label: "Status",
      property: "grade",
      responsive: {state: false}
    },
  ],
};
